// ------------------------------------
// Cria um pedido
// ------------------------------------

// Variáveis
const $form = $('#form-checkout');
const urlOrder = urlBase + 'core/acoes/checkout/order.php';
const type = $form.attr('method');
let data;
let reqAjaxSave = null;

$form.on('submit', function (ev) {
  ev.preventDefault();
  if (!previewMode) {
    // Verifica se tem uma forma de pagamento selecionada
    if (!$('.payment-item input[name="payment_method"]:checked').val()) {
      showAlert('Atenção!', 'Escolha uma forma de pagamento para continuar.', 'warning');
      return false;
    }
    orderCreate();
  }
});

// Salva o checkout
function orderCreate() {
  data = new FormData($form[0]);
  data.append('acao', 'save');
  if (reqAjaxSave != null) {
    reqAjaxSave.abort();
  }
  disableOrderBtn();
  showLoader('Por favor, aguarde...', 'Estamos processando o seu pedido.<br> Não feche esta página.');
  reqAjaxSave = $.ajax({
    url: urlOrder,
    type: type,
    data: data,
    contentType: false,
    cache: false,
    processData: false,
  })
    .done(function (result) {
      console.log(result);
      result = JSON.parse(result);
      if (result.status === 'success') {
        location.href = result.payment_url;
      } else if (result.status === 'error') {
        if (result.type === 'no_ship' && $('.shipping_ways input:checked').length > 0) {
          $('.shipping_ways input:checked').trigger('trigger-ship');
        }
        enableOrderBtn();
        hideLoader();
        showAlert('Erro', result.message, 'danger');
      } else {
        enableOrderBtn();
        hideLoader();
        showAlert('Erro', 'Não foi possível criar o pedido.', 'danger');
      }
    })
    .fail(function (xhr, status, exception) {
      console.log(exception);
      console.log('Não foi possível criar o pedido.');
      hideLoader();
      enableOrderBtn();
    });
}
